import React from 'react';
import { Switch, BrowserRouter as Router, Route } from 'react-router-dom';
import Deployment from 'src/page/Deployment';
import ZohoDeals from 'src/page/ZohoDeals';
import Maintenance from 'src/page/Maintenance';
import DynamicLinksConfig from 'src/page/DynamicLinksConfig';
import DynamicLinks from 'src/page/DynamicLinks';
import Trips from 'src/page/Trips';
import Events from 'src/page/Events';
import Vacations from 'src/page/Vacations';
import Trainings from 'src/page/Trainings';
import Requests from 'src/page/Requests';
import Notifications from 'src/page/Notifications';
import Suppliers from 'src/page/Suppliers';
import Companies from 'src/page/Companies';
import Boxes from 'src/page/Box';
import BoxDetail from 'src/page/Box/BoxDetails';
import Highlighted from 'src/page/ContentModelHighLighted';
import Orders from 'src/page/Orders';
import { isCurrentProjectBuildy } from 'src/util/projectCheckers';
import OrdersGroup from 'src/page/OrderGroup';
import { isCurrentUserAdmin, isCurrentUserRoot } from 'src/util/isCurrentUserRoot';
import OrderGroupDetail from 'src/page/OrderGroup/OrderGroupDetails';
import VacationBalance from 'src/page/Balance';
import PrivateRoute from './PrivateRoute';
import Language from '../page/Language';
import ContentModel from '../page/ContentModel';
import Content from '../page/Content';
import Files from '../page/Files';
import Images from '../page/Images';
import ContentModelDetail from '../page/ContentModelDetail';
import ContentDetail from '../page/ContentDetail';
import Login from '../page/Login';
import Reset from '../page/Reset';
import ContentNew from '../page/ContentNew/ContentNew';
import ContentModelNew from '../page/ContentModelDetail/ContentModelNew';
import RegisterDomain from '../page/MyDomains/RegisterDomains';
import CheckDomain from '../page/CheckDomain/CheckDomain';
import PaymentMethod from '../page/PaymentMethod';
import Invoices from '../page/Invoices';
import Account from '../page/Account';
import { ProjectDetails, Projects } from '../page/projects';
import PaymentCart from '../page/PaymentCart/CartPage';
import CartPaymentMethod from '../page/PaymentCart/CartPaymentMethod';
import CartOverview from '../page/PaymentCart/cartoverview';
import Customers from '../page/Authentication/Customers';
import CustomersDetail from '../page/Authentication/CustomersDetail/CustomersDetail';
import Complains from '../page/Authentication/Complains';
import ComplainsDetail from '../page/Authentication/ComplainsDetail/ComplainsDetail';
import EmailSubscription from '../page/EmailSubscriptions/index';
import EmailNotification from '../page/EmailNotifications/index';
import TextNotification from '../page/TextNotifications/index';
import Users from '../page/Users';
import MyCoins from '../page/MyCoins';
import Items from '../page/Items';
import ItemDetail from '../page/ItemDetail';
import PushNotifications from '../page/PushNotifications';
import ProviderGate from '../component/ProviderGate';
import OrderDetail from '../page/Orders/OrderDetail/index';
import Categories from '../page/Categories';
import CategoryDetail from '../page/Categories/CategoryDetail';
import Delivery from '../page/Delivery';
import Claims from '../page/Claim';
import ClaimDetail from '../page/ClaimDetail';
import ProjectSettings from '../page/Settings/ProjectSettings';
import { Resources, ResourceDetails } from '../page/Hosting/Resources';
import { Domains } from '../page/domains';
import { Cpanel } from '../page/Hosting/Cpanel';
import Email from '../page/Hosting/Email/Email';
import PaymentSubscription from '../page/PaymentSubscription';
import Comments from '../page/Comments';
import CommentsDetail from '../page/Comments/CommentDetail';
import IPay from '../page/Ipay/index';
import Reviews from '../page/Reviews';
import ReviewsDetail from '../page/Reviews/ReviewDetail/index';
import PayzeProvider from '../page/PayzeProvider';
import ContentReview from '../page/ContentReview';
import ContentReviewDetail from '../page/ContentReviewDetail';

const AppRouter = () => {
  return (
    <Router>
      <React.StrictMode>
        <Switch>
          <PrivateRoute path="/domains">
            <ProviderGate provider="domain">
              <Domains />
            </ProviderGate>
          </PrivateRoute>
          <PrivateRoute path="/resources/:resourceId">
            <ProviderGate provider="Hosting">
              <ResourceDetails />
            </ProviderGate>
          </PrivateRoute>
          <PrivateRoute path="/resources">
            <ProviderGate provider="Hosting">
              <Resources />
            </ProviderGate>
          </PrivateRoute>
          <PrivateRoute path="/cpanel">
            <ProviderGate provider="Hosting">
              <Cpanel />
            </ProviderGate>
          </PrivateRoute>
          <PrivateRoute path="/email">
            <ProviderGate provider="Hosting">
              <Email />
            </ProviderGate>
          </PrivateRoute>
          <PrivateRoute path="/settings/providers">
            <ProjectSettings />
          </PrivateRoute>
          <PrivateRoute path="/settings/deployment">
            <Deployment />
          </PrivateRoute>
          <PrivateRoute path="/settings/dynamic-links-config">
            <DynamicLinksConfig />
          </PrivateRoute>
          <PrivateRoute path="/authentication/customers/:customerId">
            <CustomersDetail />
          </PrivateRoute>
          <PrivateRoute path="/authentication/customers">
            <Customers />
          </PrivateRoute>
          <PrivateRoute path="/authentication/complains/:complainId">
            <ProviderGate provider="authorization">
              <ComplainsDetail />
            </ProviderGate>
          </PrivateRoute>
          <PrivateRoute path="/authentication/complains">
            <ProviderGate provider="authorization">
              <Complains />
            </ProviderGate>
          </PrivateRoute>
          <PrivateRoute path="/dynamic-links">
            <DynamicLinks />
          </PrivateRoute>
          <PrivateRoute path="/email-subscription">
            <EmailSubscription />
          </PrivateRoute>
          <PrivateRoute path="/domains/register">
            <RegisterDomain />
          </PrivateRoute>
          <PrivateRoute path="/users">
            <Users />
          </PrivateRoute>
          <PrivateRoute path="/claims/:claimToken">
            <ProviderGate provider="claims">
              <ClaimDetail />
            </ProviderGate>
          </PrivateRoute>
          <PrivateRoute path="/claims">
            <ProviderGate provider="claims">
              <Claims />
            </ProviderGate>
          </PrivateRoute>
          <PrivateRoute path="/push-notifications">
            <ProviderGate provider="push notifications">
              <PushNotifications />
            </ProviderGate>
          </PrivateRoute>
          <PrivateRoute path="/email-notification">
            <ProviderGate provider="Email Notifications">
              <EmailNotification />
            </ProviderGate>
          </PrivateRoute>
          <PrivateRoute path="/balance">
            <ProviderGate provider="Vacation Balance">
              <VacationBalance />
            </ProviderGate>
          </PrivateRoute>
          <PrivateRoute path="/requestsActions/trainings">
            <ProviderGate provider="Request Actions">
              <Trainings />
            </ProviderGate>
          </PrivateRoute>
          <PrivateRoute path="/requestsActions/vacations">
            <ProviderGate provider="Request Actions">
              <Vacations />
            </ProviderGate>
          </PrivateRoute>
          <PrivateRoute path="/requestsActions/requests">
            <ProviderGate provider="Request Actions">
              <Requests />
            </ProviderGate>
          </PrivateRoute>
          <PrivateRoute path="/box/:boxId">
            <ProviderGate provider="Box">
              <BoxDetail />
            </ProviderGate>
          </PrivateRoute>
          <PrivateRoute path="/box">
            <ProviderGate provider="Box">
              <Boxes />
            </ProviderGate>
          </PrivateRoute>
          <PrivateRoute path="/events">
            <ProviderGate provider="Events">
              <Events />
            </ProviderGate>
          </PrivateRoute>
          <PrivateRoute path="/payment-subscriptions">
            <ProviderGate provider="Payment Subscriptions">
              <PaymentSubscription />
            </ProviderGate>
          </PrivateRoute>
          <PrivateRoute path="/text-notification">
            <ProviderGate provider="Text Notifications">
              <TextNotification />
            </ProviderGate>
          </PrivateRoute>
          <PrivateRoute path="/notifications">
            <ProviderGate provider="notifications">
              <Notifications />
            </ProviderGate>
          </PrivateRoute>
          <PrivateRoute path="/payze">
            <ProviderGate provider="payze">
              <PayzeProvider />
            </ProviderGate>
          </PrivateRoute>
          <PrivateRoute path="/content-model/new">
            <ContentModelNew />
          </PrivateRoute>
          <PrivateRoute path="/content-model/:contentModelId">
            <ContentModelDetail />
          </PrivateRoute>
          <PrivateRoute path="/content-model">
            <ContentModel />
          </PrivateRoute>
          <PrivateRoute path="/content/new">
            <ContentNew />
          </PrivateRoute>
          <PrivateRoute path="/content/:contentId">
            <ContentDetail />
          </PrivateRoute>
          <PrivateRoute path="/content">
            <Content />
          </PrivateRoute>
          <PrivateRoute path="/content-review/:contentReviewId">
            <ContentReviewDetail />
          </PrivateRoute>
          <PrivateRoute path="/content-review">
            <ContentReview />
          </PrivateRoute>
          <PrivateRoute path="/Files">
            <Files />
          </PrivateRoute>
          <PrivateRoute path="/images">
            <Images />
          </PrivateRoute>
          <PrivateRoute path="/language">
            <Language />
          </PrivateRoute>
          <PrivateRoute path="/highlight">
            <Highlighted />
          </PrivateRoute>
          <PrivateRoute path="/ecommerce/sellers">
            <ProviderGate provider="E-commerce">
              <Suppliers />
            </ProviderGate>
          </PrivateRoute>
          <PrivateRoute path="/ecommerce/companies">
            <ProviderGate provider="E-commerce">
              <Companies />
            </ProviderGate>
          </PrivateRoute>
          <PrivateRoute path="/ecommerce/orders/:orderId">
            <ProviderGate provider="E-commerce">
              <OrderDetail />
            </ProviderGate>
          </PrivateRoute>
          <PrivateRoute path="/ecommerce/orders">
            <ProviderGate provider="E-commerce">
              <Orders />
            </ProviderGate>
          </PrivateRoute>
          <PrivateRoute path="/ecommerce/orders-group/:orderId">
            <ProviderGate
              canSee={isCurrentProjectBuildy && (isCurrentUserRoot || isCurrentUserAdmin)}
              provider="E-commerce"
            >
              <OrderGroupDetail />
            </ProviderGate>
          </PrivateRoute>
          <PrivateRoute path="/ecommerce/orders-group">
            <ProviderGate
              canSee={isCurrentProjectBuildy && (isCurrentUserRoot || isCurrentUserAdmin)}
              provider="E-commerce"
            >
              <OrdersGroup />
            </ProviderGate>
          </PrivateRoute>
          <PrivateRoute path="/ecommerce/delivery">
            <ProviderGate provider="E-commerce">
              <Delivery />
            </ProviderGate>
          </PrivateRoute>
          <PrivateRoute path="/ecommerce/categories/:categoryId">
            <ProviderGate provider="E-commerce">
              <CategoryDetail />
            </ProviderGate>
          </PrivateRoute>
          <PrivateRoute path="/ecommerce/categories">
            <ProviderGate provider="E-commerce">
              <Categories />
            </ProviderGate>
          </PrivateRoute>
          <PrivateRoute path="/ecommerce/items/:itemId">
            <ProviderGate provider="E-commerce">
              <ItemDetail />
            </ProviderGate>
          </PrivateRoute>
          <PrivateRoute path="/ecommerce/items">
            <ProviderGate provider="E-commerce">
              <Items />
            </ProviderGate>
          </PrivateRoute>
          <PrivateRoute path="/ecommerce/comments/:commentId">
            <ProviderGate provider="E-commerce">
              <CommentsDetail />
            </ProviderGate>
          </PrivateRoute>
          <PrivateRoute path="/ecommerce/comments">
            <ProviderGate provider="E-commerce">
              <Comments />
            </ProviderGate>
          </PrivateRoute>
          <PrivateRoute path="/ipay">
            <ProviderGate provider="iPay">
              <IPay />
            </ProviderGate>
          </PrivateRoute>
          <PrivateRoute path="/ecommerce/reviews/:review">
            <ProviderGate provider="E-commerce">
              <ReviewsDetail />
            </ProviderGate>
          </PrivateRoute>
          <PrivateRoute path="/ecommerce/reviews">
            <ProviderGate provider="E-commerce">
              <Reviews />
            </ProviderGate>
          </PrivateRoute>
          <PrivateRoute path="/cart/payment-method/overview">
            <CartOverview />
          </PrivateRoute>
          <PrivateRoute path="/cart/payment-method">
            <CartPaymentMethod />
          </PrivateRoute>
          <PrivateRoute path="/cart">
            <PaymentCart />
          </PrivateRoute>
          <PrivateRoute path="/payment-method">
            <PaymentMethod />
          </PrivateRoute>
          <PrivateRoute path="/payments/mycoins/transactions">
            <MyCoins />
          </PrivateRoute>
          <PrivateRoute path="/payments/zohodeals">
            <ProviderGate provider="Zoho Deals">
              <ZohoDeals />
            </ProviderGate>
          </PrivateRoute>
          <PrivateRoute path="/payments/maintenance">
            <Maintenance />
          </PrivateRoute>
          <PrivateRoute path="/trips">
            <ProviderGate provider="SAIT">
              <Trips />
            </ProviderGate>
          </PrivateRoute>
          <PrivateRoute path="/invoices">
            <Invoices />
          </PrivateRoute>
          <PrivateRoute path="/account">
            <Account />
          </PrivateRoute>
          <PrivateRoute path="/projects/:projectId">
            <ProjectDetails />
          </PrivateRoute>
          <PrivateRoute path="/projects">
            <Projects />
          </PrivateRoute>
          <Route path="/login">
            <Login />
          </Route>
          <Route path="/reset">
            <Reset />
          </Route>
          <Route path="/checkdomain">
            <CheckDomain />
          </Route>
          <PrivateRoute path="/">
            {/* <Home/> */}
            <ContentModel />
          </PrivateRoute>
        </Switch>
      </React.StrictMode>
    </Router>
  );
};

export default AppRouter;
